'use client';

import { useLayoutEffect } from 'react';
import type { StoryData } from '@/services/ten-years-stories';
import {
  getStoryBackdrop,
  markStoryRendered,
} from '../../_utils/story-transition';
import { STORY_TITLE_ID } from '../../_const/stories';
import StoryArticle, {
  StoryArticleProfile,
  StoryArticleSection,
} from './story-article';
import StoryHeader from './story-header';
import StoryMedia, { StoryMediaPlayer } from './story-media';

/** 스토리 본문 조립(모달·단독 페이지 공용). 부품끼리는 서로를 import 하지 않는다 */
export default function StoryContent({ content }: { content: StoryData }) {
  // 이전/다음으로 바뀐 스토리가 그려졌다고 전환에 알린다. 단독 페이지에는 기다리는 전환이 없어 아무 일도 없다
  useLayoutEffect(() => {
    markStoryRendered();
  }, [content.day]);

  return (
    <>
      <StoryMedia>
        {/* 스토리가 바뀌면 재생 상태를 초기화한다 */}
        <StoryMediaPlayer
          key={content.day}
          content={content}
          backdrop={getStoryBackdrop(content.day, content.poster)}
        />
      </StoryMedia>
      <div className="ty-story-body">
        <StoryHeader day={content.day} titleId={STORY_TITLE_ID} />
        {content.type === 'article' && (
          <StoryArticle>
            {content.blocks.map((block, i) =>
              block.kind === 'text' ? (
                <StoryArticleSection key={i} heading={block.heading}>
                  {block.body}
                </StoryArticleSection>
              ) : (
                <StoryArticleProfile
                  key={i}
                  image={block.image}
                  name={block.name}
                  description={block.description}
                />
              ),
            )}
          </StoryArticle>
        )}
      </div>
    </>
  );
}
